<template>
  <PopUp
    v-if="isActive.popup"
    bottom
    title="匯入"
    :width="width"
    :clickOutsideClose="false"
    :popUpActive="isActive.popup"
    class="lv-popup-upload-excel"
    @click="$_onClose"
  >
    <div v-show="ingStep === 0">
      <ValidationObserver ref="ValidationObserver">
        <WsRow>
          <WsCol cols="4" smcols="12">
            <StateDatePickerInput
              v-model="article.announceAt"
              title="修正發布日"
              leadingIcon="icon-datestart"
              class="mb-20"
            />
          </WsCol>
          <WsCol cols="4" smcols="12">
            <StateDatePickerInput
              v-model="article.effectAt"
              title="生效日"
              leadingIcon="icon-datestart"
              class="mb-20"
              rules="required"
            />
          </WsCol>
          <WsCol cols="4" smcols="12">
            <LvStateGuidelineStatus
              v-model="article.guidelineStatus"
              title="施行狀態"
              label="施行狀態"
              :scrollTop="scrollTop"
              :isCreatable="isCreatable"
              :isUpdatable="isUpdatable"
              :isDeletable="isDeletable"
            />
          </WsCol>
        </WsRow>
      </ValidationObserver>
    </div>
    <div v-if="ingStep === 1">
      <WsRow class="mb-8">
        <WsCol v-if="exampleName" cols="3" smcols="12">
          <WsButton001
            outLine
            :isloading="isLoading.import"
            @click="$_onDownloadExample"
          >
            {{ $t('下載{file}範本',{file:'xlsx'}) }}
          </WsButton001>
        </WsCol>
        <WsCol cols="3" smcols="12">
          <WsButton001
            outLine
            :isloading="isLoading.import"
            @click="$_handleUploadBtnClick"
          >
            {{ $t('匯入{file}檔案',{file:'xlsx'}) }}
          </WsButton001>
        </WsCol>
      </WsRow>
      <input
        ref="fileInput"
        class="lv-popup-upload-excel__input"
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        @change="$_onChange($event)"
      >
      <grid v-if="_hasData" :auto-width="true" :resizable="true" :cols="excel.headers" :rows="excel.table"></grid>
      <LlEmptyPic
        v-else
        title="目前尚無資料"
        :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
      />
    </div>
    <div v-if="ingStep === 2">
      <LvText class="mb-16"> {{ $t('按住方框上下左右拖曳，以調整上下順序及左右層級') }} </LvText>
      <LvStateSortList :list="sortList"/>
    </div>
    <template #bottomBtn>
      <WsButton001
        outLine
        :isloading="isLoading.submit"
        @click="$_onClose"
      >
        {{ $t('取消') }}
      </WsButton001>
      <WsButton001
        v-if="ingStep !== 0"
        :isloading="isLoading.import || isLoading.submit"
        @click="ingStep --"
      >
        {{ $t('上一步') }}
      </WsButton001>
      <WsButton001
        v-if="ingStep !== 2"
        :isloading="isLoading.import"
        :disable="ingStep === 1 && !file"
        @click="ingStep ++"
      >
        {{ $t('下一步') }}
      </WsButton001>
      <WsButton001
        v-if="ingStep === 2"
        :isloading="isLoading.submit"
        @click="$_onSubmit"
      >
        {{ $t('確定') }}
      </WsButton001>
    </template>
  </PopUp>
</template>

<script>
import Grid from 'gridjs-vue';
import H_time from '@/helpers/time';
import H_excel from '@/helpers/excel';
import S_guidelineArticleAdmin from '@/service/api/v1/guidelineArticleAdmin';

export default {
  components: {
    Grid
  },
  props: {
    width: {
      type: String,
      default: '90vw'
    },
    exampleName: {
      type: String,
    },
    scrollTop: {
      type: [Number, String],
    },
    isCreatable: {
      type: Boolean,
      default: false,
    },
    isUpdatable: {
      type: Boolean,
      default: false,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
    articleList: {
      type: Array,
    },
    guidelineId: {
      type: String,
    },
    versionId: {
      type: String,
    },
  },
  data() {
    return {
      isActive: {
        popup: false,
      },
      isLoading: {
        import: false,
        submit: false,
      },
      ingStep: 0,
      article: {
        announceAt: '',
        effectAt: '',
        guidelineStatus: '',
      },
      excel: {
        headers: [],
        table: [],
      },
      file: null,
      sortList: []
    }
  },
  computed: {
    _hasData() {
      return this.excel.headers.length > 0;
    },
  },
  methods: {
    $_onOpen({announceAt, effectAt, guidelineStatus}) {
      this.isActive.popup = true;
      this.article = {
        announceAt,
        effectAt,
        guidelineStatus,
      };
    },
    $_onClose() {
      if (this.isLoading.submit) return;
      this.isActive.popup = false;
      this.ingStep = 0;
      this.article = {
        announceAt: '',
        effectAt: '',
        guidelineStatus: '',
      };
      this.excel = {
        headers: [],
        table: [],
      };
      this.file = null;
      this.sortList = [];
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    $_handleUploadBtnClick() {
      this.$refs.fileInput.click();
    },
    async $_onChange($event) {
      this.file = $event.target.files[0];
      this.isLoading.import = true;
      const {headers, table} = await H_excel.parse(this.file);
      this.excel.headers = headers;
      this.excel.table = table;
      this.sortList = this.$_setSortList(headers, table, this.article);
      this.isLoading.import = false;
    },
    $_setSortList(headers, table, article) {
      const {announceAt, effectAt, guidelineStatus: guideline_status} = article;
      return table.reduce((acc, item, itemIndex) => {
        const resultItem = item.reduce((obj, value, index) => {
          obj[headers[index]] = value;
          return obj;
        }, {});
        const commonProps = {
          id: itemIndex + 1,
          parent_id: null,
          sequence: null,
          announce_at: H_time.getDateDashFormat(announceAt, 'YYYY-MM-DD HH:mm:ssZ'),
          effect_at: H_time.getDateDashFormat(effectAt, 'YYYY-MM-DD HH:mm:ssZ'),
          guideline_status,
          rich_content: `<p style="line-height: 1.5;font-size: 1.125rem;">${resultItem.content}</p>`,
          no_text: resultItem.name,
          children: [],
        };
        acc.push({...resultItem, ...commonProps});
        return acc;
      }, []);
    },
    async $_onSubmit() {
      this.isLoading.submit = true;
      const lastSequence = this.$_getStartSequence(this.articleList);
      const order = this.$_setSubmitData(this.sortList, lastSequence, this.guidelineId);
      await S_guidelineArticleAdmin.batch(this.versionId, order);
      this.isLoading.submit = false;
      this.$emit('imported');
      this.$_onClose();
    },
    $_onDownloadExample() {
      const fileUrl = `${process.env.BASE_URL}${this.exampleName}.xlsx`;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = 'example.xlsx';
      link.click();
    },
    $_setSubmitData(rawDataList, lastSequence, guidelineId) {
      const order = [];
      function setSortItem(item, parentSequence = null, parent_id, index = 0) {
        const {
          id,
          name,
          content,
          children,
          announce_at,
          effect_at,
          guideline_status,
          rich_content,
          no_text,
        } = item;
        const sequence = parentSequence ? `${parentSequence}-${(index + 1).toString().padStart(4, '0')}` : (lastSequence + index + 1).toString().padStart(4, '0');
        order.push({
          id,
          name,
          parent_id,
          sequence,
          announce_at,
          effect_at,
          guideline_status,
          rich_content,
          no_text,
          content,
          type: children && children.length > 0 ? 'title' : 'article',
        });
        if (children && children.length > 0) {
          children.forEach((child, childIndex) => {
            setSortItem(child, sequence, id, childIndex);
          });
        }
      }
      rawDataList.forEach((item, index) => {
        setSortItem(item, null, '', index);
      });
      return {
        guideline: guidelineId,
        data: order,
      };
    },
    $_getStartSequence(articleList) {
      if (!articleList || !articleList.length) return 0;
      const firstLayerItems = articleList.filter(article => !article.parentId);
      return  parseInt(firstLayerItems[firstLayerItems.length - 1].sequence);
    }
  }
}
</script>